// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"ed2113b5","336":"997fdc6e","360":"fb8695ad","408":"39b746f7","453":"e9e7ec89","544":"866d9788","743":"7f7796fe","777":"60f8d2dc","822":"ec360cc5","858":"713a3fd6","888":"7c6c35d4","986":"bfbeeeac"}[chunkId] + ".chunk.js";
};